import { analyzesSchema, analyzeSchema } from "@/schemas/analyze";

import { getAppUrl } from "@/helper/url";

import { propertyTabSearchParam } from "@/filters";

import type { AnalyzeFilter, House } from "@/types";

const url = `${getAppUrl()}/api/analyzes`;

export const fetchAnalyzes = async () => {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Falha ao buscar análises de matrículas");
    }

    const data = await response.json();

    return analyzesSchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar análises de matrículas:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao buscar análises de matrículas"
    );
  }
};

export const fetchAnalyze = async ({ id, field = "id" }: AnalyzeFilter) => {
  try {
    const response = await fetch(
      `${url}/${id}?${propertyTabSearchParam.campo}=${field}`
    );

    if (field === "numero_do_leilao" && response.status === 404) {
      return null;
    }

    if (!response.ok) {
      throw new Error("Falha ao buscar detalhes da análise de matrícula");
    }

    const data = await response.json();

    return analyzeSchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar detalhes da análise de matrícula:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao buscar detalhes da análise de matrícula"
    );
  }
};

export const postAnalyze = async (property: House, registryText: string) => {
  const response = await fetch(`${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ property, registryText }),
  });

  if (!response.ok) {
    throw new Error("Falha ao salvar análise de matrícula");
  }

  const data = await response.json();

  return data;
};
